import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EnhancePhotoTranslateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"enhance_photo_translate"}/>
}
